import client from "../client";
import { PRInterface } from "../../models/ProcurementModule/PurchaseRequest";

const listName = "PurchaseRequestModule";

class PRService {
  async GetAll(page: number, pageSize: number) {
    try {
      const { data } = await client.post<PRInterface[]>(
        `/api/${listName}/get`,
        {
          page,
          pageSize,
        }
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async GetById(id: string) {
    try {
      const { data } = await client.get<PRInterface>(
        `/api/${listName}/getbyid/${id}`
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Create(item: PRInterface) {
    try {
      const url = `/api/${listName}/create`;
      const formData = new FormData();

      for (const key in item) {
        if (key !== "uploadedFiles") {
          formData.append(key, (formData as any)[key]);
        }
      }

      const { data } = await client.post<PRInterface>(url, item);

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Update(id: string, item: PRInterface) {
    try {
      const { data } = await client.post<PRInterface>(
        `/api/${listName}/update/${id}`,
        item
      );

      return data;
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async Remove(id: string) {
    try {
      const { data } = await client.post<PRInterface>(
        `/api/${listName}/remove/${id}`,
        { url: "" }
      );
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
  async AddPurchaseOrder(id: string): Promise<boolean> {
    try {
      const { status } = await client.post<any>(
        `/api/${listName}/addPurchaseOrder/${id}`,
        { url: "" }
      );
      if (status === 200) {
        return true;
      }

      return false;
    } catch (error) {
      console.log("API Error:", error);
      return false;
    }
  }
}

export default new PRService();
